module.exports = __webpack_public_path__ + "img/xcx.0d7ed40e.jpg";